export default __webpack_public_path__ + "static/alphaandomegalk-89c2ae90eb767c5c82e45ef715df5380.png";